import { useSofaFeed } from "@/hooks/useSofaFeed";
import { useDevices } from "@/hooks/useDevices";
import { VulnerabilityDashboard } from "@/components/patching/vulnerabilities/VulnerabilityDashboard";
import { VulnerabilityLoadingSkeleton } from "@/components/patching/vulnerabilities/VulnerabilityLoadingSkeleton";

export default function VulnerabilitiesPage() {
  const { data: devices } = useDevices();
  const sofaFeed = useSofaFeed();

  if (sofaFeed.isLoading) {
    return <VulnerabilityLoadingSkeleton loadedCount={sofaFeed.loadedCount} totalCount={sofaFeed.totalCount} />;
  }

  if (sofaFeed.error) {
    return (
      <div className="text-center py-12">
        <p className="text-destructive font-medium">Failed to load vulnerability feeds</p>
        <p className="text-sm text-muted-foreground mt-1">{String(sofaFeed.error)}</p>
      </div>
    );
  }

  return (
    <div className="bg-background w-full">
      <div className="w-full px-6 py-6 space-y-6">
        <VulnerabilityDashboard
          releases={sofaFeed.releases}
          totalCVEs={sofaFeed.totalCVEs}
          activelyExploitedCount={sofaFeed.activelyExploitedCount}
          lastCheck={sofaFeed.lastCheck}
          devices={devices || []}
          onRefresh={sofaFeed.refetch}
          isRefreshing={sofaFeed.isRefetching}
          loadedCount={sofaFeed.loadedCount}
          totalCount={sofaFeed.totalCount}
          cacheStatus={sofaFeed.cacheStatus}
          lastDataUpdate={sofaFeed.lastDataUpdate}
        />
      </div>
    </div>
  );
}
